export default {
      id: "icon-kind-usage",
      viewBox: "0 0 41.832 28.229",
      url: __webpack_public_path__ + "img/icons.c8a27ec6.svg#icon-kind",
      toString: function () {
        return this.url;
      }
    }